import React from 'react';

import { RootStateOrAny, useSelector } from 'react-redux';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { Paragraph } from '../../styles/paragraph';
import { getInfluencerItemCountExcludingMembership } from '../../utils/selectors';

const InfluencerToastMessage = styled(Paragraph).attrs({
  size: '12',
  align: 'center',
})`
  font-weight: 300;
  letter-spacing: 0.3px;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.active};
  padding: 9px 28px;
`;

const TotalItem = styled.span`
  font-weight: bold;
`;

export function CartDrawerInfluencerToastMessage() {
  const cartItemInfluencerCount = useSelector(
    getInfluencerItemCountExcludingMembership
  );
  const { influencerInfo, isInfluencer } = useSelector(
    (state: RootStateOrAny) => state.customer
  );
  const influencerLimit = influencerInfo?.maxProductQty;

  if (!isInfluencer) {
    return null;
  }

  if (
    typeof influencerLimit === 'number' &&
    cartItemInfluencerCount <= influencerLimit
  ) {
    const total = `${cartItemInfluencerCount}/${influencerLimit}`;
    return (
      <InfluencerToastMessage>
        <FormattedMessage
          id="global_checkout.influencer_number_items"
          defaultMessage="You've added {total} items to your cart."
          values={{
            total: <TotalItem>{total}</TotalItem>,
          }}
        />
      </InfluencerToastMessage>
    );
  } else {
    return null;
  }
}
